import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../service/proveedores/proveedores.service'
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { CambiarEstatusDialogComponent } from '../../cambiar-estatus-dialog/cambiar-estatus-dialog.component';


@Component({
  selector: 'app-validar-proveedor-dialog',
  templateUrl: './validar-proveedor-dialog.component.html',
  styleUrl: './validar-proveedor-dialog.component.scss'
})
export class ValidarProveedorDialogComponent {

  proveedorForm: FormGroup
  model
  editMode = true
  errorValidarCorreo = false
  headerTitle = 'Validar Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false,
    group5: false
  };
  mostrarError = {
    nombre: false,
    razonSocial: false,
    rfc: false,
    moneda: false,
    correo: false,
    direccion: false,
    telefono: false,
    contacto: false,
    noCuenta: false, 
    tipoCompra: false,
    tipoPersona: false,
    regimenFiscal: false,
    condicionesPago: false,
    diasPago: false,
    titular: false,
    idCif:false,
    empresa: false
  }
  tipoMoneda = []
  formasPago = []
  tipoCompra = []
  regimenFiscal = []
  bancos = []
  condicionesPago = []
  estatus = []
  tipoPersona = []
  empresas = []
  empresaSelect = []
  loadingView = true
  step = 1
  validEmail = false

  selectedFile: File | null = null;
  pdfSrc: any = '';
  pdfName: any = ''
  selectedFile2: File | null = null;
  pdfSrc2: any = '';
  pdfName2: any = ''
  selectedFile3: File | null = null;
  pdfSrc3: any = '';
  pdfName3: any = ''
  selectedFile4: File | null = null;
  pdfSrc4: any = '';
  pdfName4: any = ''
  pdfSrc6: any = '';
  pdfName6: any = '';
  monedaSelect = []
  rowCode = ''
  condicionPagoId: number;


  show(groupName) {
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
    this.gallery.group5 = (groupName == 'group5') ? true : false;
    
  }
  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private provedorService: ProveedoresService,
    public dialogRef: MatDialogRef<ValidarProveedorDialogComponent>) {
      this.proveedorForm = this.fb.group({
        clave: ['', [Validators.required]],
        nombre: ['', [Validators.required]],
        //razonSocial: ['', [Validators.required]],
        razonSocial: [{value:'', disabled: true}],
        tipo: ['', [Validators.required]],
        rfc: ['', [Validators.required]],
        moneda: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        telefono: ['', [Validators.required]],
        correo: ['', [Validators.required]],
        contacto: ['', [Validators.required]],
        noCuenta: ['', [Validators.required]],
        condicionesPago: ['', [Validators.required]],
        tipoCompra: ['', [Validators.required]],
        tipoPersona: ['', [Validators.required]],
        regimenFiscal: ['', [Validators.required]],
        diasPago: ['', [Validators.required]],
        formasPago: ['', [Validators.required]],
        titular: ['', [Validators.required]],
        estatus: ['', [Validators.required]],
        banco:  ['', [Validators.required]],
        idRfc: ['', [Validators.required]]
      })

      this.editMode = data.editable
      this.getTipoMoneda()
      this.getTipoCompra()
      this.getCondicionesPago()
      this.getEstatus()
      this.getRegimenFiscal()
      this.getTipoPersona()
      this.getBancos()
      //this.getFormasPago()
      this.getProveedorData(data.proveedor)

      this.headerTitle = 'Validar Proveedor - ' + data.proveedor.nombreProveedor
      this.getEmpresas()
      if(data.mostrarDocumentos){
        this.step = 4
      }
  }

  ngOnInit() {

  }

  getEmpresas(){
    this.provedorService.getEmpresas(localStorage.getItem('id')).subscribe(
      data => {
        this.empresas = data
      }
    )
  }

  getTipoMoneda(){
    this.provedorService.getTiposMoneda().subscribe(
      data => {
        this.tipoMoneda = data
      }
    )
  }
  
  getBancos(){
    this.provedorService.getBancos().subscribe(
      data => {
        this.bancos = data
      }
    )
  }
  
  getTipoCompra(){
    this.provedorService.getTiposCompra().subscribe(
      data => {
        this.tipoCompra = data
      }
    )
  }

  getEstatus(){
    this.provedorService.getProveedoresEstatus().subscribe(
      data => {
        this.estatus = data
      }
    )
  }

  getFormasPago(id, formaPagoId){

    this.provedorService.getFormaPago(id).subscribe(
      data => {
        this.formasPago = data
        this.proveedorForm.get('formasPago').setValue(formaPagoId);
      }
    )
  }

  getCondicionesPago(){
    this.provedorService.getCondicionesPago().subscribe(
      data => {
        this.condicionesPago = data
      }
    )
  }

  getRegimenFiscal(){
    this.provedorService.getRegimenFiscal().subscribe(
      data => {
        this.regimenFiscal = data
      }
    )
  }

  getTipoPersona(){
    this.provedorService.getTipoPersona().subscribe(
      data => {
        this.tipoPersona = data
      }
    )
  }

  getProveedorData(proveedor){
    this.provedorService.getProveedorPorClave(proveedor.claveProveedor).subscribe(
      datos => {
        let data = datos[0]
        this.proveedorForm = this.fb.group({
          clave: new FormControl({value: data.claveProveedor, disabled: true}, [Validators.required]),
          nombre: new FormControl({value: data.nombreProveedor, disabled: true}, [Validators.required]),
          razonSocial: new FormControl({value: data.razonSocial, disabled: true}, [Validators.required]),
          rfc: new FormControl({value: data.rfc, disabled: true}, [Validators.required]),
          moneda: new FormControl({value: data.moneda, disabled: true}, [Validators.required]),
          direccion: new FormControl({value: data.direccion, disabled: true}, [Validators.required]),
          telefono: new FormControl({value: data.telefono, disabled: true}, [Validators.required]),
          correo: new FormControl({value: data.email, disabled: true}, [Validators.required]),
          //correo: [data.email, [Validators.required]],
          contacto: new FormControl({value: data.contactoFacturacion, disabled: true}, [Validators.required]),
          noCuenta: new FormControl({value: data.numerodeCuenta, disabled: true}, [Validators.required]),
          condicionesPago: new FormControl({value: data.condiciondePagoId, disabled: true}, [Validators.required]),
          tipoCompra: new FormControl({value: data.tipoCompra, disabled: true}, [Validators.required]),
          diasPago: new FormControl({value: data.diasdePago, disabled: true}, [Validators.required]),
          tipoPersona: new FormControl({value: data.tipoProveedor, disabled: true}, [Validators.required]),
          regimenFiscal: new FormControl({value: data.regimenFiscal, disabled: true}, [Validators.required]),
          formasPago: new FormControl({value: data.formaPagoId, disabled: true}, [Validators.required]),
          titular: new FormControl({value: data.nombreTitular, disabled: true}, [Validators.required]),
          estatus: new FormControl({value: data.estatus, disabled: false}, [Validators.required]),
          banco:  new FormControl({value: data.bancosId, disabled: true}, [Validators.required]),
          idRfc:  new FormControl({value: data.idCIF, disabled: true}, [Validators.required]),
        })
        data.tiposMonedaProveedor.forEach(element => {
          this.monedaSelect.push(element.tipoMonedaId)
        });
        data.proveedorEmpresa.forEach(element => {
          this.empresaSelect.push(element.empresaId)
        });

        data.documentosproveedor.forEach(element => {
          if(element.claveDocumento === 'CSF'){
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'CD'){
            this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'CB'){
            this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'REP'){
            this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if (element.claveDocumento === 'OCF') {
              this.pdfSrc6 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
              this.pdfName6 = element.archivo;
          }
        });
        this.loadingView = false
        this.rowCode = data.rowVersion
        this.validarEmail(this.proveedorForm.get('correo').value);

        this.condicionPagoId = data.condiciondePagoId;
        this.getFormasPago(this.condicionPagoId,data.formaPagoId)
      }
    )
  }

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }       
  }

  validateStep(opc){
    this.resetErrors()
    if(this.step === 1){
      if(this.proveedorForm.value.nombre !== '' && this.proveedorForm.value.razonSocial !== '' && this.proveedorForm.value.rfc !== '' && this.proveedorForm.value.moneda !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.nombre = this.proveedorForm.value.nombre !== '' ? false : true
        this.mostrarError.razonSocial = this.proveedorForm.value.razonSocial !== '' ? false : true
        this.mostrarError.rfc = this.proveedorForm.value.rfc !== '' ? false : true
        this.mostrarError.moneda = this.proveedorForm.value.moneda !== '' ? false : true
      }
    }else if(this.step === 2){
      if(this.proveedorForm.value.correo !== '' && this.proveedorForm.value.direccion !== '' && this.proveedorForm.value.telefono !== '' && this.proveedorForm.value.contacto !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.correo = this.proveedorForm.value.correo !== '' ? false : true
        this.mostrarError.direccion = this.proveedorForm.value.direccion !== '' ? false : true
        this.mostrarError.telefono = this.proveedorForm.value.telefono !== '' ? false : true
        this.mostrarError.contacto = this.proveedorForm.value.contacto !== '' ? false : true
      }
    }else
     if(this.step === 3){
      if(this.proveedorForm.value.noCuenta !== '' && this.proveedorForm.value.tipoCompra !== '' && this.proveedorForm.value.tipoPersona !== '' && this.proveedorForm.value.regimenFiscal !== '' && this.proveedorForm.value.condicionesPago !== '' && this.proveedorForm.value.diasPago !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.noCuenta = this.proveedorForm.value.noCuenta !== '' ? false : true
        this.mostrarError.tipoCompra = this.proveedorForm.value.tipoCompra !== '' ? false : true
        this.mostrarError.tipoPersona = this.proveedorForm.value.tipoPersona !== '' ? false : true
        this.mostrarError.regimenFiscal = this.proveedorForm.value.regimenFiscal !== '' ? false : true
        this.mostrarError.condicionesPago = this.proveedorForm.value.condicionesPago !== '' ? false : true
        this.mostrarError.diasPago = this.proveedorForm.value.diasPago !== '' ? false : true
      }
    }else{
      this.nextStep(opc)
    }
  }

  nextStep(opc){
    opc === 1 ? this.step ++ : this.step --
  }

  async guardarProveedor(){

    const dialogRef = this.dialog.open(CambiarEstatusDialogComponent, {
      width: 'auto',
      data: {
        data: this.data,
        estatus: this.proveedorForm.value.estatus
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 1) {
        let body = {
          proveedorId: this.data.proveedor.proveedorId,
          estatus: result.estatus,
          observaciones: result.observacion,
          updatedBy: localStorage.getItem('id'),    
          rowVersion: this.rowCode  
        }
        this.provedorService.updateStatus(body).subscribe(
          data => {
            if(data.code === 400){
              const dialogRef = this.dialog.open(ErrorDialogComponent, {
                width: 'auto',
                data: {
                  message: data.message
                }
              });
            }else if(data.code === 200){
              this.dialogRef.close({event: 1, data: data})
            }
          },
          error => {
            console.log(error)
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto',
              data: {
                isError: true,
                message: error.error.message                
              }
            });
            this.dialogRef.close({event: 2})
          }
        )
      }

    });
    

   
    
  }

  enviarArchivo(opc){
    const formData = new FormData();
    if(opc === 1){
      formData.append('fileProvider', this.selectedFile);
    }else if(opc === 2){
      formData.append('fileProvider', this.selectedFile2);
    }else if(opc === 3){
      formData.append('fileProvider', this.selectedFile3);
    }else if(opc === 4){
      formData.append('fileProvider', this.selectedFile4);
    }
    this.provedorService.enviarPdf(formData).subscribe(
      data => {

      }
    )
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        width: 'auto',
        data: {
          message: 'Por favor, selecciona un archivo PDF'
        }
      });
    }
  }

  previewPDF(file: File, opc, $event): void {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const pdfData = e.target.result;
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      if(opc === 1){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CSF.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName = auxFile.name
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile = auxFile;
      }else if(opc === 2){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CD.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName2 = auxFile.name
        this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile2 = auxFile;
      }else if(opc === 3){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CB.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName3 = auxFile.name
        this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile3 = auxFile;
      }else if(opc === 4){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-REP.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName4 = auxFile.name
        this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile4 = auxFile;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  resetErrors(){
    this.mostrarError = {
      nombre: false,
      razonSocial: false,
      rfc: false,
      moneda: false,
      correo: false,
      direccion: false,
      telefono: false,
      contacto: false,
      noCuenta: false, 
      tipoCompra: false,
      tipoPersona: false,
      regimenFiscal: false,
      condicionesPago: false,
      diasPago: false,
      titular: false,
      idCif:false,
      empresa:false
    }
  }

  resetUploadFile(opc){
    if(opc === 1){
      this.pdfName = ''
      delete this.pdfSrc
      delete this.selectedFile
    }else if(opc === 2){
      this.pdfName2 = ''
      delete this.pdfSrc2
      delete this.selectedFile2
    }else if(opc === 3){
      this.pdfName3 = ''
      delete this.pdfSrc3
      delete this.selectedFile3
    }else if(opc === 4){
      this.pdfName4 = ''
      delete this.pdfSrc4
      delete this.selectedFile4
    }
    // this.file_loaded = []; 
    // this.wrongFileExtension = false
  }

  repseHabilitado(){
    return this.proveedorForm.value.tipoCompra !== '1' ? false : true 
  }

  get monedasTexto(): string {
    if (!this.tipoMoneda?.length || !this.monedaSelect?.length) {
      return '';
    }

    return this.tipoMoneda
      .filter(m => this.monedaSelect.includes(m.tipoMonedaId))
      .map(m => `${m.clave} - ${m.descripcion}`)
      .join(', ');
  }

  get empresasTexto(): string {
    if (!this.empresas?.length || !this.empresaSelect?.length) {
      return '';
    }

    return this.empresas
      .filter(e => this.empresaSelect.includes(e.empresaId))
      .map(e => e.nombreEmpresa)
      .join(', ');
  }
}
